<template>
  <div class="date-range">
    <div class="date-range__date">
    <span class="date-range__text">
      <slot name="before-text">
      </slot>
    </span>

    <el-date-picker
      class="date-range__date-picker"
      v-model="start"
      :format="$t('base.dateFormat')"
      :picker-options="{ disabledDate: disabledDateStart }"
      :key="`${name}-start`"
      value-format="yyyy-MM-dd"
      type="date"
      :placeholder="placeholderStart">
    </el-date-picker>
    </div>

    <div class="date-range__date">
    <span v-if="range" class="date-range__text">
        <slot name="between-text"></slot>
    </span>

      <el-date-picker
        v-if="range"
        class="date-range__date-picker"
        v-model="end"
        :format="$t('base.dateFormat')"
        :picker-options="{ disabledDate: disabledDateEnd }"
        :key="`${name}-end`"
        value-format="yyyy-MM-dd"
        type="date"
        :placeholder="placeholderEnd">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {
      },
      type: Object,
    },
    range: {
      default: true,
      type: Boolean,
    },
    name: {
      default: '',
      type: String,
    },
    disabledDate: {
      default: () => false,
      type: Function,
    },
    placeholderStart: {
      default: '',
      type: String,
    },
    placeholderEnd: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      start: undefined,
      end: undefined,
    };
  },
  methods: {
    disabledDateStart(time) {
      return this.disabledDate(time);
    },
    disabledDateEnd(time) {
      const startDate = new Date(this.start);
      return this.disabledDate(time)
          || (
            new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60 * 1000)
              .toISOString().slice(0, 10)
            && time.toISOString().slice(0, 10) < this.start);
    },
  },
  watch: {
    range(newValue) {
      if (!newValue) {
        this.end = null;
        const value = {
          ...this.value,
          end: null,
        };
        this.$emit('input', value);
      }
    },
    start(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.end && newValue >= this.end) {
          this.end = new Date(
            new Date(newValue).getTime() + 1000 * 60 * 60 * 24,
          ).toISOString().slice(0, 10);
        }
        const value = {
          ...this.value,
          start: newValue,
        };
        this.$emit('input', value);
      }
    },
    end(newValue, oldValue) {
      if (newValue !== oldValue) {
        const value = {
          ...this.value,
          end: newValue,
        };
        this.$emit('input', value);
      }
    },
    value: {
      handler(newValue) {
        if (newValue && (newValue.start !== this.start)) {
          this.start = newValue.start;
        }
        if (newValue && this.range && (newValue.end !== this.end)) {
          this.end = newValue.end;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">

  .date-range {
    font-size: $--font-size-small;
    display: flex;
    flex-direction: column;
    justify-items: start;
    @include breakpoint(mobile){
      margin-left: -10px;
      font-size: $--font-size-large;
      flex-direction: row;
    }
    &__date{
      margin-top: .4em;
    }
    &__text {
      color: $--color-text-primary;
      display: inline-block;
      width: 50px;
      margin: 0 10px 10px 0;

      @include breakpoint(mobile){
        width: auto;
        margin: 0 10px;
      }
    }
  }

  ::v-deep .el-input {
    height: 42px;
    border-radius: $--border-radius-base;
  }
</style>
